import type { AxiosPromise } from 'axios'
import qs from 'qs'
import request from '@user-center/utils/request'
import store from '@user-center/store'

import { zhTranFn } from '@user-center/utils/zh'

// 批量提交售后订单（换货/退货）
export function batchAfterSaleOrder(params: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/batchAfterSaleOrder',
    method: 'post',
    params: { ...params },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  })
}

// 恢复取消订单
export function renewPlatformCancelOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/renewPlatformCancelOrder',
    method: 'post',
    data,
  })
}

// 保存卖家备注
export function saveSellerMessage(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/saveSellerMessage',
    method: 'post',
    data,
  })
}

// 同步独立站漏单
export function repairSztshopLeakedOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/repairSztshopLeakedOrder',
    method: 'post',
    data,
  })
}

// 保存采集1688商品
export function autoSaveAlibabaGoods(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/saveAlibabaGoodsTask', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}
// 通用保存采集方法
export function saveGoodsTask(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/saveGoodsTask', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

export function savePddGoods(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/savePddGoods', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

// 采集商品记录
export function listCollectionGoodsLog(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/listCollectionGoodsTask',
    method: 'post',
    data: { ...data },
  })
}

// 删除采集商品记录
export function deleteGoodsInfoLog(data: any): AxiosPromise<unknown> {
  return request({
    url: `/collectionGoods/deleteGoodsInfoTask/${data.id}`,
    method: 'get',
  })
}

// 批量删除采集商品记录
export function batchDeleteGoodsInfoLog(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/batchDeleteGoodsInfoTask',
    method: 'post',
    data: [...data],
  })
}

// 采集商品列表
export function listCollectionGoods(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/listCollectionGoods', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

export function updateCollectionRemark(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/updateSpuRemark', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

// 认领商品到店铺
export function claimCollectionGoods(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/claimCollectionGoods', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 上架采集商品
export function pushSpuDetailInfoOnShopee(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/pushSpuDetailInfoOnShopee', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

// 获取商品详情
export function querySpuDetailInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/querySpuDetailInfo', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

// 保存采集商品
export function updateSpuInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/updateSpuInfo', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  })
}

export function updateCollectionSpuInfo(data: any, options: any = { returnAll: false }): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/updateCollectionSpuInfo', // 配置url
    method: 'post', // 配置请求方式
    data: { ...data },
  }, options)
}

// 删除采集商品
export function batchDeleteGoodsInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/batchDeleteGoodsInfo', // 配置url
    method: 'post', // 配置请求方式
    data,
  })
}

// 批量保存采集任务
export function batchSaveCollectionTask(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/batchSaveCollectionTask',
    method: 'post',
    data,
  })
}

// 发布记录列表
export function listCollectionTask(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/listCollectionTask',
    method: 'post',
    data,
  })
}

// 批量删除发布记录
export function batchDeleteCollectionTask(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/batchDeleteCollectionTask',
    method: 'post',
    data,
  })
}

// 获取店铺物流渠道列表
export function getLogisticsChannelList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/getLogisticsChannelList',
    method: 'post',
    data,
  })
}

export function listOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '',
    method: 'post',
    data,
  })
}
export function saveGoodsPushSetting(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsPushSetting/save',
    method: 'post',
    data,
  })
}

export function listGoodsPushSetting(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsPushSetting/listGoodsPushSetting',
    method: 'post',
    data,
  })
}

export function updateGoodsPushSetting(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsPushSetting/update',
    method: 'post',
    data,
  })
}

export function goodsPushSettingById(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsPushSetting/queryDetailById',
    method: 'post',
    data,
  })
}

export function deleteGoodsPushSetting(data: any): AxiosPromise<unknown> {
  return request({
    url: `/goodsPushSetting/delete/${data}`,
    method: 'get',
    data,
  })
}

export function listGoodsSupplyRelation(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsSupplyRelation/listGoodsSupplyRelation',
    method: 'post',
    data,
  })
}

export function createGoodsSupplyRelation(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsSupplyRelation/create',
    method: 'post',
    data,
  })
}

export function deleteGoodsSupplyRelation(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsSupplyRelation/delete',
    method: 'post',
    data,
  })
}

export function updateGoodsSupplyRelation(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsSupplyRelation/update',
    method: 'post',
    data,
  })
}

// 导入关联货源
export function uploadGoodsSupplyRelation(data: any): AxiosPromise<unknown> {
  return request({
    url: '/goodsSupplyRelation/upload',
    method: 'post',
    data,
  })
}

export function queryOrdersOnPage(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrdersOnPage',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

export function queryOrderById(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderById',
    method: 'post',
    params: data,
  })
}

// 平台订单枚举（订单状态等）
export function listPlatformOrderEnums(): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/listPlatformOrderEnums',
    method: 'get',
  })
}

export function queryOrderStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

// 独立站订单统计（新接口）
export function sztShopQueryOrderStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/sztShopQueryOrderStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

// 独立站订单分页查询（新接口）
export function sztShopQueryOrdersOnPage(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/sztShopQueryOrdersOnPage',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

export function queryOrderCargoTypeStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderCargoTypeStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

export function queryOrderWaybillPrintStatusStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderWaybillPrintStatusStatistics',
    method: 'post',
    data,
  })
}

export function queryOrderPickupPrintStatusStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderPickupPrintStatusStatistics',
    method: 'post',
    data,
  })
}

export function queryOrderForwarderStatusStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderForwarderStatusStatistics',
    method: 'post',
    data,
  })
}

export function queryOrderPackageArrivalStatusStatistics(data: any): AxiosPromise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    data = {
      ...data,
      subGroupId: store.getters.subGroupId,
    }
  }
  return request({
    url: 'admin/platform/order/queryOrderPackageArrivalStatusStatistics',
    method: 'post',
    data,
  })
}

export function orderDetailPurchase(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailPurchase',
    method: 'post',
    data,
  })
}

export function orderDetailPurchaseV2(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailPurchase',
    method: 'post',
    data,
  })
}

export function orderCheckRealPay(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/orderCheckRealPay',
    method: 'post',
    data,
  })
}

export function queryOrderCollectTask(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderCollectTask',
    method: 'post',
    data,
  })
}

export function orderDetailConfirmPurchase(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailConfirmPurchase',
    method: 'post',
    data,
  })
}

export function orderDetailConfirmPurchaseV2(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailConfirmPurchaseV2',
    method: 'post',
    data,
  })
}

export function orderDetailConfirmPurchaseAndReturn(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailConfirmPurchaseAndReturn',
    method: 'post',
    data,
  })
}

export function getConfirmPurchaseFailTypeList(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/getConfirmPurchaseFailTypeList',
    method: 'post',
    data,
  })
}

export function orderConfirmPurchaseClearOne(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/orderConfirmPurchaseClearOne',
    method: 'post',
    data,
  })
}

export function orderDetailInventoryDelivery(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderDetailInventoryDelivery',
    method: 'post',
    data,
  })
}

export function getShopeeCategory(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/getCategory',
    method: 'post',
    data,
  })
}

export function synchronizeOrderByTime(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/synchronizeOrderByTime',
    method: 'post',
    data,
  })
}

export function repairLeakedOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/repairLeakedOrder',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

export function renderPlatformOrderList(): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/renderPlatformOrderList',
    method: 'post',
  })
}

export function pullBackOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/pullBackOrder',
    method: 'post',
    data,
  })
}

export function orderSelfPack(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderSelfPack',
    method: 'post',
    data,
  })
}

export function orderBatchSelfPack(data: any): AxiosPromise<unknown> {
  data.shopNick = zhTranFn(data.shopNick, 's')
  return request({
    url: 'admin/platform/order/orderBatchSelfPack',
    method: 'post',
    data,
  })
}

export function updateTargetItemCategory(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/updateTargetItemCategory',
    method: 'post',
    data,
  })
}

// 店铺产品统计
export function queryProductInfoStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/queryProductInfoStatistics',
    method: 'post',
    data,
  })
}

// 店铺产品列表
export function listProduct(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/listProduct',
    method: 'post',
    data,
  })
}

export function updateProductInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/updateProductInfo',
    method: 'post',
    data,
  })
}

export function syncProductInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/syncProductInfo',
    method: 'post',
    data,
  })
}

export function deleteProductItem(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/deleteItem',
    method: 'post',
    data,
  })
}

// 上下架商品
export function unlistItem(data: any[]): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/unlistItem',
    method: 'post',
    data,
  })
}

// 获取分类属性列表
export function getAttributes(data: any): AxiosPromise<unknown> {
  return request({
    url: '/collectionGoods/getAttributeTree',
    method: 'post',
    data,
  })
}

// 批量更新商品价格
export function updateSkuPrice(data: any[]): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/updateSkuPrice',
    method: 'post',
    data,
  })
}

// 批量更新商品库存
export function updateSkuStock(data: any[]): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/updateSkuStock',
    method: 'post',
    data,
  })
}

// 批量更新商品备货信息
export function updateBatchPreOrder(data: any[]): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/updateBatchPreOrder',
    method: 'post',
    data,
  })
}

// 上传图片到虾皮
export function uploadImageShopee(data: any): AxiosPromise<unknown> {
  return request({
    url: '/productInfo/uploadImage',
    method: 'post',
    data,
  })
}

// 仓库商品创建
export function saveItemInfoAndSpu(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/iteminfo/saveItemInfoAndSpu',
    method: 'post',
    data,
  })
}

// 仓库商品编辑
export function updateItemInfoSpu(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/iteminfo/updateItemSpu',
    method: 'post',
    data,
  })
}

// 仓库商品库存查询
export function queryItemSkuInventoryList(data: any): AxiosPromise<unknown> {
  return request({
    url: `/admin/itemSkuInventory/queryItemSkuInventoryListByOuterItemSkuId/${data.id}`,
    method: 'get',
  })
}
//
export function queryItemSkuInventoryListByOuterItemSkuIds(data: any): AxiosPromise<unknown> {
  return request({
    url: `/admin/itemSkuInventory/queryItemSkuInventoryListByOuterItemSkuIds`,
    method: 'post',
    data,
  })
}

// 保存库存同步规则
export function saveItemSkuInventorySyncRule(data: any): AxiosPromise<unknown> {
  return request({
    url: `/admin/itemSkuInventorySyncRule/save`,
    method: 'post',
    data,
  })
}

// 编辑库存同步规则
export function updateItemSkuInventorySyncRule(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuInventorySyncRule/update',
    method: 'post',
    data,
  })
}

export function querySyncRuleOnPage(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/itemSkuInventorySyncRule/querySyncRuleOnPage',
    method: 'post',
    data,
  })
}

export function removeItemSkuInventorySyncRule({ id }: { id: string }): AxiosPromise<unknown> {
  return request({
    url: `/admin/itemSkuInventorySyncRule/remove/${id}`,
    method: 'get',
  })
}

export function importOrderDetailConfirmPurchase(data: FormData, headers): AxiosPromise<unknown> {
  data.set('shopNick', zhTranFn(data.get('shopNick') as string, 's'))
  return request({
    url: 'admin/platform/order/importOrderDetailConfirmPurchase',
    method: 'post',
    data,
    headers,
  })
}

export function importOrderDetailConfirmPurchaseV2(data: FormData, headers): AxiosPromise<unknown> {
  data.set('shopNick', zhTranFn(data.get('shopNick') as string, 's'))
  return request({
    url: 'admin/platform/order/importOrderDetailConfirmPurchaseV2',
    method: 'post',
    data,
    headers,
  })
}

// 申请运单
export function applyWaybill(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/applyWaybill',
    method: 'post',
    data,
  })
}
// 打印面单
export function getPrintWayBill(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/getPrintWayBill',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}
// 批量预刷订单
export function batchPreMarking(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/batchPreMarking',
    method: 'post',
    data,
  })
}

// 获取拣货单数据
export function getPickUpData(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/getPickUpData',
    method: 'post',
    data,
  })
}

// 批量修改备注3
export function batchUpdateOrderRemarks(
  data: any,
): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/batchUpdateOrderRemarks',
    method: 'post',
    data,
  })
}

// 批量修改采购备注
export function batchUpdatePurchaseRemarks(
  data: any,
): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/batchUpdatePurchaseRemarks',
    method: 'POST',
    data,
  })
}

// 设置卖家/商家备注
export function setSellerNote(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/setSellerNote',
    method: 'POST',
    data,
  })
}

export function queryUnreadNotificationsCount(

): AxiosPromise<unknown> {
  return request({
    url: '/member/workOrder/queryUnreadNotificationsCount',
    method: 'POST',
    data: { param: {} },
  })
}

// 添加订单明细
export function savePlatformOrderDetail(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/savePlatformOrderDetail',
    method: 'post',
    data,
  })
}

// 删除订单明细
export function deletePlatformOrderDetailById(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/deletePlatformOrderDetailById',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 添加组合商品
export function addComboItem(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/addComboItem',
    method: 'post',
    data,
  })
}

// 隔离订单
export function batchIsolateOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/update2Isolation',
    method: 'post',
    data,
  })
}

// 订单统计
export function queryOrderHandleStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderHandleStatistics',
    method: 'post',
    data,
  })
}

// 操作日志
export function queryOrdersOperationLogOnPage(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/queryOrdersOperationLogOnPage',
    method: 'POST',
    data,
  })
}

// 授权登录列表
export function hardwareVerificationList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/hardwareVerification/queryPage',
    method: 'POST',
    data,
  })
}

// 授权登录create
export function hardwareVerificationCreate(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/hardwareVerification/create',
    method: 'POST',
    data,
  })
}

// 授权登录modify
export function hardwareVerificationModify(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/hardwareVerification/modify',
    method: 'POST',
    data,
  })
}

// 授权登录delete
export function hardwareVerificationDelete(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/hardwareVerification/delete',
    method: 'POST',
    data,
  })
}

// 标记缺货发货
export function batchSetPlatformOrderDetailOutOfStock(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/batchSetPlatformOrderDetailOutOfStock',
    method: 'post',
    data,
  })
}

export function decideAndSet2NeedSyncForwarder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/decideAndSet2NeedSyncForwarder',
    method: 'post',
    data,
  })
}

// 查询订单分页
export function queryClaimOrderOnPage(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryOrdersOnPage',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

// 创建索赔订单
export function createClaimOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/create',
    method: 'post',
    data,
  })
}

// 修改索赔订单
export function modifyClaimOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/modify',
    method: 'post',
    data,
  })
}

// 提交代打包订单
export function submitSaleOrderHeader(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/submitSaleOrderHeader',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 出货关联明细统计
export function queryOrderDetailFinishStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderDetailFinishStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

export function queryOrderDetailCollectingFinishStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderDetailCollectingFinishStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

export function queryOrderOnePackageMultipleOrderSignStatistics(data: any): AxiosPromise<unknown> {
  return request({
    url: 'admin/platform/order/queryOrderOnePackageMultipleOrderSignStatistics?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

export function queryClaimPaymentList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/claimPaymentList/queryPage?hiddenErrTip=1',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

export function queryClaimStatusList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimStatusList?hiddenErrTip=1',
    method: 'post',
    data,
  }, {

  })
}

export function queryClaimSubjectList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimSubjectList?hiddenErrTip=1',
    method: 'post',
    data,
  }, {

  })
}

export function queryClaimTypeList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimTypeList?hiddenErrTip=1',
    method: 'post',
    data,
  }, {

  })
}

export function queryClaimReasonList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimReasonList?hiddenErrTip=1',
    method: 'post',
    data,
  }, {

  })
}

export function getClaimServiceDetailInfo(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/getClaimServiceDetailInfo?hiddenErrTip=1',
    method: 'post',
    data,
  }, {
    returnAll: true,
  })
}

export function queryClaimCurrencyList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimCurrencyList?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

export function deleteClaimOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/delete',
    method: 'post',
    data,
  })
}

export function queryClaimPaymentOptions(data: any): AxiosPromise<unknown> {
  return request({
    url: '/portal/claimOrder/queryClaimPaymentList',
    method: 'post',
    data,
  })
}

// 重新匹配货物类型
export function updatePlatformOrderCargoType(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/updatePlatformOrderCargoType',
    method: 'post',
    data,
  })
}

// 批量更新货物类型
export function batchUpdateCargoType(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/batchUpdateCargoType',
    method: 'post',
    data,
  })
}

export function getShowWarehouseWeight(): AxiosPromise<unknown> {
  return request({
    url: '/portal/user/getShowWarehouseWeight',
    method: 'post',
  })
}

export function readyToShipResetOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/readyToShipResetOrder',
    method: 'post',
    data,
  })
}

export function sztShopCancelPlatformOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/cancelSztshopPlatformOrder',
    method: 'post',
    data,
  })
}

export function batchCancelSztshopPlatformOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/platform/order/batchCancelSztshopPlatformOrder',
    method: 'post',
    data,
  })
}

// 修改SztShop订单
export function modifyOrderSztshop(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/sztshop/modifyOrder',
    method: 'post',
    data,
  })
}

// 查询SztShop商品列表
export function querySztShopItemSpuList(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/sztshop/itemSpuList',
    method: 'post',
    data,
  })
}

// Shopee 取消订单
export function shopeeCancelOrder(data: any): AxiosPromise<unknown> {
  return request({
    url: '/shopee/order/cancelOrder',
    method: 'post',
    data,
  })
}

// 查询SztShop门店地址列表
export function querySztShopAddress(data: any): AxiosPromise<unknown> {
  return request({
    url: '/admin/sztshop/queryShopAddress',
    method: 'post',
    data,
  })
}

export const claimPaymentStatusMap = { 1: '待打款', 2: '打款中', 3: '打款完成', 4: '取消打款', 5: '打款失败' }
export const claimPaymentStatusColorMap = { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger', 5: 'danger' }

export const orderPurchaseTemplateURL = 'admin/platform/order/downloadOrderDetailConfirmPurchaseTemplate'

export const siteOptions = [
  { value: 'SG', lang: 'en', label: '新加坡' },
  { value: 'MY', lang: 'ms-my', label: '马来西亚' },
  { value: 'VN', lang: 'vi', label: '越南' },
  { value: 'TW', lang: 'zh-hant', label: '台湾' },
  { value: 'PH', lang: 'en', label: '菲律宾' },
  { value: 'TH', lang: 'th', label: '泰国' },
  { value: 'ID', lang: 'id', label: '印度尼西亚' },
  { value: 'BR', lang: 'pt-br', label: '巴西' },
  { value: 'MX', lang: 'es-mx', label: '墨西哥' },
  { value: 'CO', lang: 'es-CO', label: '哥伦比亚' },
  { value: 'CL', lang: 'es-CL', label: '智利' },
  { value: 'PL', lang: 'en', label: '波兰' },
  { value: 'ES', lang: 'en', label: '西班牙' },
  { value: 'FR', lang: 'en', label: '法国' },
  { value: 'IN', lang: 'en', label: '印度' },
  { value: 'AR', lang: 'en', label: '阿根廷' },
]
